import { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";
// import { useMutation } from "@apollo/client";
// import { ReportUnReview, ReportReview } from "../../apollo-client/api-query";
// import { showErrorToast } from "../../utils/toast";

const DETAILFELLOW_STATUS = [
  {
    title: 'Yes',
    value: true,
  },
  {
    title: 'No',
    value: false 
  }
]

export default function DetailFellowSwitch({needsReview, onClick}) {

  const [selected, setSelected] = useState(needsReview)
  useEffect(() => {
    setSelected(needsReview)
  }, [needsReview]);

  return (
    <Box 
      sx={{
        bgcolor: selected ? 'primary.mediumGreen' : 'primary.mediumGray',
        border: '0px solid',
        borderRadius: '40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '22px',
        width: !selected ? '83px' : '83px',
        padding: selected ? '4px 4px 4px 8px' : '4px 8px 4px 4px',
        flexShrink: 0,
        cursor: 'pointer'
      }}
      onClick={onClick}
    >
      {DETAILFELLOW_STATUS.map(option => (
        <Box
          key={option.title}
          sx={{
            width: !selected === option.value ? '16px' : 'auto',
            height: !selected === option.value ? '16px' : '100%',
            borderRadius: !selected === option.value ? '50%' : '0px',
            textAlign: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            background: !selected === option.value ? 'white' : 'transparent',
          }}
        >
          <Typography
            key={option.value}
            variant="h4"
            sx={{
              color: 'primary.white',
              whiteSpace: 'nowrap',
              display: !selected === option.value ? 'none' : 'block',
              lineHeight: '15px'
            }}
          >
            {option.title}
          </Typography>
        </Box>
      ))}
    </Box>
  )
}